import React from 'react';
import { BsGithub, BsLinkedin } from 'react-icons/bs';
import { SiLeetcode } from 'react-icons/si';


const SocialMedia = () => (
  <div className="app__social">
    <div> <a href="https://in.linkedin.com/in/sandeep-kumar-75643619b">
      <BsLinkedin/></a>
    </div>
    <div> <a href="https://github.com/Sandivsv">
      <BsGithub/></a>
    </div>
    <div> <a href="https://leetcode.com/Sandivsv">
      <SiLeetcode /></a>
    </div>
  </div>
);

export default SocialMedia;